import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  statistiken: [],
  loading: false,
  error: null
}

// getters
const getters = {
  statistiken (state) {
    return state.statistiken
  },
  statistik: (state) => (id) => {
    return state.statistiken.find(statistiken => statistiken.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadStatistiken ({commit}) {
    commit('setLoading', true)
    console.log('Statistiken laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('statistik').orderBy('monat')
    .onSnapshot(snapshot => {
      const statistiken = []
      snapshot.forEach(doc => {
        statistiken.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedStatistiken', statistiken)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createStatistiken ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('statistik').add(payload)
      .then(key => {
        commit('createStatistiken', {
          ...payload,
          id: key.id
        })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteStatistikenData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('statistik').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteStatistiken', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateStatistikenData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('statistik').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateStatistiken', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedStatistiken (state, payload) {
    state.statistiken = payload
  },
  createStatistiken (state, payload) {
    state.statistiken.push(payload)
  },
  updateStatistiken (state, payload) {
    const statistiken = state.statistiken.find(statistiken => {
      return statistiken.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        statistiken[key] = payload[key]
      }
    })
  },
  deleteStatistiken (state, payload) {
    let array = state.statistiken
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.statistiken = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/statistiken_alt.js